import moment from "moment-timezone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { useCompanyTimeFormat } from "../../../../utils/hooks/company";
import { smallText } from "./constants";

const styles = {
    card: { border: "1px solid #e9ecef", borderRadius: 8, padding: 12, gap: 12 },
    dateTile: { width: 44, alignSelf: "flex-start", border: "1px solid #e9ecef", borderRadius: 6, overflow: "hidden" },
    dateMonth: { fontSize: 10, letterSpacing: 0.5, background: "#f6f7f9", padding: "2px 0" },
    dateDay: { fontSize: 16, lineHeight: "26px" },
};

const ImpactRow = ({ icon, title, startDate, endDate, children }) => {
    const timeFormat = useCompanyTimeFormat();
    const start = moment.parseZone(startDate);
    const end = moment.parseZone(endDate);

    return (
        <div className="d-flex align-items-start" style={styles.card}>
            <div className="d-flex flex-column align-items-center flex-shrink-0" style={styles.dateTile}>
                <span className="w-100 text-center text-uppercase text-muted font-weight-bold" style={styles.dateMonth}>
                    {start.format("MMM")}
                </span>
                <span className="font-weight-bold" style={styles.dateDay}>{start.format("D")}</span>
            </div>

            <div className="d-flex flex-column flex-grow-1" style={{ minWidth: 0, gap: 4 }}>
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                    <span className="font-weight-bold">
                        <FontAwesomeIcon icon={icon} className="text-muted mr-2" size="sm" />
                        {title}
                    </span>
                    <span className="text-muted" style={smallText}>
                        <FontAwesomeIcon icon={faClock} className="mr-1" />
                        {start.format(`ddd, ${timeFormat}`)} - {end.format(end.isSame(start, "day") ? timeFormat : `ddd, ${timeFormat}`)}
                    </span>
                </div>
                {children}
            </div>
        </div>
    );
};

export default ImpactRow;
